export default "__VITE_ASSET__88a5d4f5__"